<template>
  <div class="page">
    <div class="main-container">


    <div class="search">
      <div class="search-box">
        <div style="width: 86%">
          <form @submit.prevent="formSubmit" action="javascript:return true">
            <input ref="searchInput" v-model="searchTerm" type="search" placeholder="请输入您要查询的内容"
                   class="search-input" @keydown="search2($event)"/>
          </form>
        </div>
        <span class="cancel" @click="cancel" v-if="searchTerm !== ''">
          <img src="../assets/img/close.png"/>
        </span>
        <div style="width: 10%">
          <button onClick="history.back();">取消</button>
        </div>
      </div>
      <div v-show="showResults" class="results" style="background-color: transparent;">
        <template v-if="results.length > 0">

          <div class="content-topic">
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="`${index+1}.${result.question}`" :name="`${index}`" v-for="(result, index) in results" :key="index">
              <div class="item-content">
                <p v-html="formatAnswer(result.answer)"></p>
              </div>
            </el-collapse-item>

<!--            <van-collapse v-model="activeNames" accordion :border="false">-->
<!--              <van-collapse-item :title="result.question"-->
<!--                                 :title-class="activeNames ===result.activeNames ? 'checked-title' :'unchecked'"-->
<!--                                 :name="result.activeNames"-->
<!--                                 :icon="activeNames===result.activeNames  ? 'circle2 iconfont' :'circle'"-->
<!--                                 :is-link="true">-->
<!--                <div class="item-content" style="background-color: transparent;">-->
<!--                  <p v-html="formatAnswer(result.answer)"></p>-->
<!--                  &lt;!&ndash;                    <div style="height: 10px"></div>&ndash;&gt;-->
<!--                </div>-->
<!--              </van-collapse-item>-->
<!--            </van-collapse>-->

          </el-collapse>
          </div>
        </template>
        <img v-else src="../assets/img/none.png" alt="None" class="none">
      </div>
    </div>

    </div>
    </div>
</template>


<script>
export default {
  data() {
    return {
      activeNames: '',
      questions: [
        {
          question: '未认证回复不了信息吗？',
          answer: '陌生约聊致力于打造最真实的单生男女交友社区，陌生约聊交友大数据显示完成真人认证、交友宣言认证，消息回复率提升600%。',
          activeNames: 107
        },
        {
          question: '为什么我不能语音速配？',
          answer: '语音速配功能是需要您通过了真人认证后才开启的权限。',
          activeNames: 108
        },
        {
          question: '实名认证信息可以修改吗？',
          answer: '陌生约聊是真实的交友平台，提倡真诚交友，为保障交友的真实性，实名认证信息提交后，不可进行修改哦~',
          activeNames: 125
        },
        {
          question: '如何取消认证信息？',
          answer: '陌生约聊是真实的交友平台，提倡真诚交友，为保障交友的真实性，建议用户真人、实名等认证使用，交到更多好友~\n' +
            '如您这边想将已认证信息取消，为了确保您的账号安全，需要确定您是账号所有者，请您向客服提供本人真实相关信息，请联系官方在线客服咨询。',
          activeNames: 128
        },
        {
          question: '如何真人认证？',
          answer: '点击真人认证即可进入认证页面，请按照提示进行操作，提交后请耐心等待审核，审核时间一般在2小时内。',
          activeNames: 109
        },
        {
          question: '真人认证为什么不通过？',
          answer: '真人认证需提交高清且无遮挡的人脸照片进行认证的。提交的头像过于模糊，无法判断属于同一人是无法通过审核的。',
          activeNames: 112
        },
        {
          question: '认证审核需要多久通过？',
          answer: '真人认证提交后，进入AI智能+人工审核过程，请耐心等待审核，\n' +
            '一般2小时内会处理。',
          activeNames: 113
        },
        {
          question: '实名认证怎么操作？',
          answer: '点击实名认证即可进入认证页面，请按照提示进行操作，填写相应信息后进行身认证认证即可完成认证。',
          activeNames: 114
        },
        {
          question: '实名认证不了怎么办？',
          answer: '您好，如果您实名认证不了，建议您可以在实名认证下方点击联系客服，按要求提交手持身份证进行认证，提交后请耐心等待审核。',
          activeNames: 115
        },
        {
          question: '我之前已经真人认证过，怎么没有了？',
          answer: '真人认证系统会定期检查审核，有不符合的会被取消，建议您可以操作重新提交真人认证。',
          activeNames: 116
        },
        {
          question: '语音认证怎么操作？',
          answer: '点击编辑语音签名即可录制语音签名，提交后进入AI智能+人工审核过程，\n' +
            '请耐心等待审核，\n' +
            '一般2小时内会处理 。',
          activeNames: 117
        },
        {
          question: '怎么更新语音签名？',
          answer: '点击编辑语音签名即可录制新的语音签名。',
          activeNames: 118
        },
        {
          question: '发现用户违规该如何举报？',
          answer: '陌生约聊秉承给用户创造良好网络环境原则，严厉打击违法违规行为。\n' +
            '若您发现用户涉嫌违规，可点击对方资料页右上角更多，选择举报。陌生约聊将会在收到您举报后的2小时内尽快处理，若核实被举报用户的违规行为，将予以封禁处理。',
          activeNames: 126
        },

        {
          question: '账号禁用了怎么办？',
          answer: '账号禁用有以下几种情形:\n' +
            '1)打广告\n' +
            '2)留其他联系方式\n' +
            '3)视频涉黄\n' +
            '4)敏感词违规\n' +
            '5)被多人举报\n' +
            '关于账号解封问题:\n' +
            '违规账号到系统提示的解封日期后，会自动解封\n' +
            '还有其他疑问请在工作日联系官方在线客服咨询(服务时间8:00--17:30)。',
          activeNames: 127
        },
        {
          question: '账号禁用有哪些原因？',
          answer: '账号禁用有以下几种情形:\n' +
            '1)色情违规传播色情内容\n' +
            '2)以骗钱、骗金币，诈骗为目的的行为\n' +
            '3)恶意辱骂，使用文字/图片进行攻击行为\n' +
            '4)音视频涉黄\n' +
            '5)敏感词违规\n' +
            '6)被多人举报\n' +
            '详细您可以点击陌生约聊平台用户行为规范查看账号使用规范及相应处罚。\n' +
            '为维护陌生约聊平台积极健康交友生态环境，保障用户合法权益及良好的用户体验，请遵守相关规定和法律法规，同时陌生约聊平台将严厉打击不良现象，对违规行为进行相应的处。',
          activeNames: 124
        },
        {
          question: '账号为什么会违规？',
          answer: '账号违规有以下几种情形:\n' +
            '1)打广告\n' +
            '2)留其他联系方式\n' +
            '3)视频涉黄\n' +
            '4)敏感词违规\n' +
            '5)被多人举报\n' +
            '关于账号解封问题:\n' +
            '违规账号到系统提示的解封日期后，会自动解封\n' +
            '还有其他疑问请在工作日联系官方在线客服咨询(服务时间8:00--17:30)。',
          activeNames: 42
        },
        {
          question: '账号禁用提现的钱还能到账吗？',
          answer: '如果账号兑换期间违规禁止提现；若账号禁用前已经提交了兑换申请或禁用期间提交了提现申请，系统都会根据账号违规情况进行判断审核，审核通过的即会正常到账，若审核不通过所兑换的积分是自动返还。后续账号解封正常使用是可以正常兑换提现的\n',
          activeNames: 43
        },
        {
          question: '如何注销账号？',
          answer: '关于账号注销，请点击软件底部【我的】- 【设置】一【账号与安全】选择注销账号，提交注销后需15个工作日审核，注销期间内可通过取消注销恢复账号。账号注销后相关数据在注销后将清空(余额、好友等)， 无法登陆使用，被系统收回，并对平台其他用户开放申请，请谨慎注销。',
          activeNames: 44
        },
        {
          question: '账号被禁用了还能注销吗？',
          answer: '账号被禁用后处于冻结状态，在软件内无法搜索查询，账号资料信息无法进行查看，且不支持注销，请在封禁页面优先进行账号解封申诉。',
          activeNames: 45
        },
        {
          question: '账号如何申诉解封？',
          answer: '1)若账号被禁用，需提交申诉解封申请，审核通过则账号解封，不通过则账号永久禁用，无法解封\n' +
            '2)操作流程:点击账号申诉提交申请\n' +
            '3)为确保账号安全，需核实账号所属申诉需上传:手机号码、身份证号码、手持身份证、身份证正、反面，请按要求提供，若不符标准，将会被驳回驳回后可重新提交\n' +
            '4)审核时间:提交申请后将有专门人员审核处理，审核周期为3-5天\n' +
            '5)审核结果及禁用原因会以手机短信的形式同步通知，请耐心等待并以手机短信结果为准~\n',
          activeNames: 46
        },
        {
          question: '如何签到？',
          answer: '1）点击签到，每天首次登录系统也会自动弹出签到页面\n' +
            '2）每天签到获得奖励不等（有机会获得金币、贵族、装扮等精美礼物等奖励），还有砸金蛋、开宝箱随机获得精美奖励哦～\n' +
            '3）连续签到7天可获得开启宝箱奖励\n' +
            '\n' +
            '温馨提示:同一台设备仅限每日签到一次，超出次数当日不可再次签到。',
          activeNames: 47
        },
        {
          question: '金币有什么用？',
          answer: '1)金币可用来和用户文字、语音和视频聊天，还可以赠送礼物表达心意。\n' +
            '2)金币不参与兑换，无法兑换积分\n' +
            '3)消耗的金币将产生积分，积分则可以兑换成金币、贵族、实物商品和提现。',
          activeNames: 48
        },
        {
          question: '如何充值金币？',
          answer: '在软件底部点击【我的】-【充值】-选择相应的金币面值进行充值。',
          activeNames: 49
        },
        {
          question: '私聊回复了消息，怎么金币还被退回去？',
          answer: '12小时内回复即可获得相应金币;\n' +
            '12小时内没有回复消息，金币是系统自动退回到对方的账号\n' +
            '可以在金币清单核对一下是否收到金币，聊天界面金币系统显示有可能延迟，如果有问题可以提供对方ID号给在线客服处理。',
          activeNames: 50
        },
        {
          question: '私聊对方主动发消息为什么回复没金币？',
          answer: '可以在积分清单核对一下是否收到积分，聊天界面积分系统显示有可能延迟，如果有问题可以提供对方账号给官方在线客服处理。。',
          activeNames: 51
        },
        {
          question: '金币可以兑换积分吗？',
          answer: '积分可以兑换成金币、贵族和提现，金币则无法兑换积分，金币可用来和用户文字、语音和视频聊天，还可以赠送礼物表达心意。',
          activeNames: 52
        },
        {
          question: '金币消费记录怎么查看,赚的金币在哪里查看？',
          answer: '点击消费记录可查看具体的金币消费记录。\n' +
            '在充值过程中遇到问题，可以反馈给在线客服咨询(服务时间8:00- -17:30)\n。',
          activeNames: 53
        },
        {
          question: '互相关注成为好友了为什么发信息还要收取金币？',
          answer: '互相关注即是好友，成为好友后完成实名认证双方发送信息是免费的；\n' +
            '互相关注与视频通话收费没有关系，与对方互相成为守护天使且达到LV6永结同心，互相守护后音视频通话是免费的',
          activeNames: 54
        },
        {
          question: '开通贵族后聊天为什么还需要金币？',
          answer: '贵族是陌生约聊帐户的尊贵体现，成为贵族可以享有一定的权益。不同等级的贵族享有不同的权益，您可以点击\n' +
            '开通贵族查看更详细的贵族权益;\n' +
            '陌生约聊秉持平台公正公平原则，聊天收费或免费的功能权限完全交由用户自主设置，当对方用户设置聊天需付费时发消息需付金币， 对方12小时内不回复则金币退还。加为好友(互相关注且完成实名认证)聊天免费，男女平等;\n' +
            '付费聊天，可以主动追求你喜欢的人，并得到及时回应，可靠且高效。',
          activeNames: 55
        },
        {
          question: '什么是贵族？',
          answer: '1）贵族是陌生约聊的尊贵体现，成为贵族可以享有一定的权益。\n' +
            '2）贵族包含：、骑士、子爵、伯爵、公爵、亲王、帝皇\n' +
            '3）不同等级的贵族享有不同的权益，详情请点击 贵族中心查看了解\n' +
            '4）贵族三个不同有效期：1个月、3个月、12个月。\n',
          activeNames: 56
        },
        {
          question: '贵族包月怎么取消？',
          answer: '您好，贵族暂无自动续费功能~',
          activeNames: 57
        },
        {
          question: '为什么聊天需要金币？',
          answer: '陌生约聊作为平台方为有交友需求的用户双方搭建聊天互动的桥梁，秉持平台中立性的原则，聊天免费或收费的功能权限完全交由用户自主设置;\n' +
            '当对方用户设置聊天需付费时发消息需付金币， 对方12小时内不回复则金币退还。付费聊天，可以主动追求你喜欢的人，并得到及时回应，可靠且高效；\n' +
            '每日签到可免费获得金币，你还可以通过邀请好友赚钱、做任务等方法免费获取金币。',
          activeNames: 300
        },
        {
          question: '为什么聊天要充值？',
          answer: '陌生约聊独创了付费聊天模式，聊天免费与付费，完全交由用户自主设置\n' +
            '当对方用户设置聊天需付费时发消息需付金币，对方12小时内不回复退还金币。对方用户设置免费时，发消息免费。\n' +
            '聊天付费，可以主动追求你喜欢的人，并得到及时回应；还能过滤骚扰、验证诚意，可靠又高效;\n' +
            '金币也不是必须充值，可通过做签到、做任务等方法免费获取金币。',
          activeNames: 58
        },
        {
          question: '搭讪需要花费金币吗？',
          answer: '1)搭讪是根据搜索条件、交友需求账号活跃、违规频次，聊天质量等相关信息进行智能化推荐匹配。\n' +
            '2)建议您可以主动一对一聊天提高聊天质量的，或者也可以在首页或者广场多互动。\n' +
            '3)每次搭讪需要消耗1金币\n',
          activeNames: 59
        },
        {
          question: '充值方式有以下几种？',
          answer: '在软件底部点击【我】-【充值】-选择相应的金币面值进行充值，可以使用支付宝或微信进行充值。',
          activeNames: 60
        },
        {
          question: '如何查看账号金币？',
          answer: '点击我的-充值界面即可查看您当前所有金币，在充值过程中遇到问题，请联系官方在线客服，快速解决问题。。',
          activeNames: 61
        },
        {
          question: '还有其疑问或建议，怎么办？',
          answer: '1.可以点击[问题反馈]，反馈给我们官方。\n' +
            '2.可以在APP内留言给在线客服。\n' +
            '客服时间: 08: 00-17: 30',
          activeNames: 62
        },
        {
          question: '什么是粉丝、关注、好友？',
          answer: '粉丝:即在你的资料页点击关注，并成功关注你的人，就成为你的粉丝，并在粉丝列表显示\n' +
            '关注:即在TA的资料页点击关注，你成功关注的人，就成为你的关注，并在关注列表显示\n' +
            '好友:即你关注我，我关注你，互相关注成功，就成为好友，并在好友列表显示\n' +
            '软件内点“关注”没有任何限制，互相关注且实名认证成为好友聊天免费。',
          activeNames: 63
        },
        {
          question: '怎么看我收到的礼物？',
          answer: '在个人主页底部即可查看收到的礼物。',
          activeNames: 64
        },
        {
          question: '男性用户可以提现吗？',
          answer: '系统暂未开放此功能，如有开放此功能，系统会另行通知。',
          activeNames: 65
        },
        {
          question: '怎么修改所在地？',
          answer: '陌生约聊致力于打造最真实的交友平台，为体现交友真实性，不支持修改所在地。',
          activeNames: 66
        },
        {
          question: '如何在排行榜隐身？',
          answer: '开通贵族即可在设置- -贵族特权设置里设置排行榜隐身:上榜但显示神秘人',
          activeNames: 67
        },
        {
          question: '怎么隐藏守护天使？',
          answer: '开通贵族当您成为守护天使时，即可在设置--贵族特权设置里选择匿名守护，这样其他人就不会看到守护天使的真实身份了。',
          activeNames: 68
        },
        {
          question: '为什么我发不了红包？',
          answer: '充值多少就可以发多少金币红包，温馨提示：系统赠送金币不能用来发红包。',
          activeNames: 69
        },
        {
          question: '为什么申请提现失败？',
          answer: '提现不成功可以下原因： \n' +
            '1 ．在申请提现前未完成真人认证和实名认证，若未完成，请先前往“我的认证”进行认证；\n' +
            '2 ．账户实名信息与提现账号姓名信息不一致。\n' +
            '提现失败，积分会原路退回并下发官方通知，请根据提示原因操作后重新发起提现哦。',
          activeNames: 28,
        },
        {
          question: '积分兑换的金币在哪里查看？',
          answer: '积分兑换成金币是12小时内到账，你可以点击收支记录查看具体的金币消费记录。',
          activeNames: 29,
        },
        {
          question: '提现提示需要认证？',
          answer: '在申请积分兑换之前，您的账号需要真人认证、实名认证都通过后才能提交申请。',
          activeNames: 30,
        },
        {
          question: '申请提现的时候账号信息填错了怎么办？',
          answer: '账号填写错误是无法进行打款的，提现对应金币是直接退回到提现账号的，收到退回消息后，可以点击我的-收益-兑换记录查看退回金币记录，您可以重新填写正确的提现账号信息后再申请提现。',
          activeNames: 301,
        },
        {
          question: '积分提现钱为什么还不到账？可以在哪里查看？',
          answer: '您好，系统显示兑换成功以后，您可以检查您的提现账户信息，进行核实。',
          activeNames: 31,
        },
        {
          question: '私聊回复信息为什么没有获得积分？',
          answer: '可以在积分清单核对一下是否收到积分，聊天界面积分系统显示有可能延迟，如果有问题可以提供对方账号给官方在线客服处理。',
          activeNames: 32,
        },
        {
          question: '私聊回复信息为什么得到的积分不一样？',
          answer: '发消息方需付金币，12小时内回复即可获得相应积分，请您以实际到账为准。\n' +
            '可以在积分清单核对一下是否收到积分，聊天界面积分系统显示有可能延迟，如果有问题可以提供对方ID给在线客服处理。\n',
          activeNames: 33,
        },
        {
          question: '私聊对方主动发消息，为什么回复后没积分？',
          answer: '当对方设置发消息收费时，发消息给对方需付金币，对方12小时内回复即可获得相应积分。',
          activeNames: 130,
        },
        {
          question: '如何兑换积分？',
          answer: '点击积分商城 即可选择兑换金币、提现、贵族、商城装扮等。\n' +
            '温馨提示：\n' +
            '1）兑换金币、贵族特权、商城装扮是实时到账的；\n' +
            '2）积分提现是12小时内到账。',
          activeNames: 34,
        },
        {
          question: '如何撤销兑换？',
          answer: '1)积分兑换金币、贵族、商城装扮，均是实时到账的，兑换成功无法撤销或退回\n' +
            '2)积分兑换提现，未打款前可以联系客服申请驳回，进入打款状态无法撤销;若打款失败兑换积分将退回到账号可重新提交！',
          activeNames: 35
        },
        {
          question: '如何获得积分？',
          answer: '1）聊天能得到积分，收到对方赠送礼物也可获得积分；\n' +
            '2）语音通话和视频通话也可以获得积分。\n' +
            '3）点击积分兑换 即可在积分商城选择兑换金币、提现、特权贵族。\n',
          activeNames: 36
        },
        {
          question: '提现记录在哪里查看？',
          answer: '可以在 我的兑换 查看积分兑换及提现记录。\n' +
            '在积分兑换过程中遇到问题，请联系官方在线客服咨询，快速解决问题。',
          activeNames: 37
        },
        {
          question: '提现到账时间/提现还没到账？',
          answer: '提现打款:\n' +
            '1)首次提现5元面额是实时到账的\n' +
            '2)提现其他面额一般情况下12小时内到账\n' +
            '3)每日提现有次数限制，建议不要频繁操作\n' +
            '4)打款是批量进行的，都会依次到账，留意通知，注意查收',
          activeNames: 38
        },
        {
          question: '提现到账的金额为什么不一样？',
          answer: '1)提现金额累计超过500元，需要缴纳税费，提现到账后会扣取相应的手续费，还望理解\n' +
            '2)积分商城兑换提现所需积分请以页面实际显示为准\n' +
            '3)建议在使用过程中维护好账号，系统也会根据账号使用情况进行综合评估\n' +
            '4)账号积分还可以在积分商城兑换金币、特权权限等\n。',
          activeNames: 39
        },

        {
          question: '积分提现方式有哪些？',
          answer: '积分提现目前仅支持支付宝提现方式，请以实际页面推荐显示为准。\n' +
            '温馨提示：支付宝收款账号必须与陌生约聊账号实名信息保持一致，否则将会导致提现失败',
          activeNames: 1,
        },
        {
          question: '积分可以聊天吗？',
          answer: '您好，不可以，金币可用来在软件内聊天和赠送礼物。\n' +
            '您可以点击软件底部【我】-【积分】，就可以看到积分能兑换金币，聊天是消耗金币。',
          activeNames: 2
        },
        {
          question: '为什么大家都喜欢用陌生约聊交友？',
          answer: '[普惠]不用担心无人关注!\n' +
            '陌生约聊以去中心化的运营理念，推行算法平权，给予用户平等的展示与匹配机制，致力于让每一位普通用户都得到推荐和关注;\n' +
            '[真实]不用担心聊天是机器人回复!\n' +
            '在陌生约聊，用户经过系统+人工双重审核，有超过9成的用户已通过真人认证;\n' +
            '[高效]不用担心发送消息石沉大海!\n' +
            '陌生约聊智能的Al匹配算法，能为你快速推荐相互有好感的异性，搭讪聊天回复率高，平均回复等待时间不超过9秒;\n' +
            '\n' +
            '聊天交友，就上陌生约聊!',
          activeNames: 143,
        },
        {
          question: '发不了信息，提示充值？',
          answer: '陌生约聊独创了付费聊天模式，聊天免费与付费，完全交由用户自主设置;\n' +
            '当对方用户设置聊天需付费时发消息需付金币，对方12小时内不回复退还金币。\n' +
            '对方用户设置免费时，发消息免费。\n' +
            '聊天付费，可以主动追求你喜欢的人，并得到及时回应；还能过滤骚扰、验证诚意，可靠又高效;\n' +
            '金币也不是必须充值，可通过做签到、做任务等方法免费获取金币。',
          activeNames: 144,
        },
        {
          question: '怎样才能获得更多金币？',
          answer: '每日签到可免费获得金币，你还可以通过做任务等方法免费获取金币。如果他人主动向您发消息、赠送您礼物，都会给您增加积分。\n' +
            '您的积分积累到一定程度可以兑换相对应的金币。',
          activeNames: 145,
        },
        {
          question: '亲密度为什么会下降？',
          answer: ' 1)亲密度下降的比例是系统根据您与对方的具体互动情况自动判定哦\n' +
            '2)亲密度下降即会进行提醒，并下发小秘书通知\n' +
            '3)可以通过与对方互动赠礼保持亲密度。\n' +
            '4)维持亲密度的方法:赠送对方魅力值级别乘以10对应的金币额，即如果对方魅力值是16级，那么每天送给对方160金币以上就可以维持当前的亲密度了哦。\n' +
            '5)当守护等级达到“终身守护”时，则双方亲密度永不下降，它将成为一段美丽佳话，永流传在平台。\n',
          activeNames: 146,
        },
        {
          question: '如何成为对方守护？',
          answer: '1)当达到守护对方所需亲密度，就成为对方守护天使。\n' +
            '2)守护分10级: LV1-LV10， 亲密度越高等级越高。\n' +
            '3)每个人只有一个守护天使。\n' +
            '4)你守护我，同时我也守护了你，即是互相守护;互相守护的用户可以上亲密榜，按双方亲密度之和排名。\n' +
            '5)守护等级达到了10级，并亲密度达到了最高即会显示终身守护，成为终身守护后，与对方的亲密度将不再下降\n' +
            '温馨提示:文字、语音、视频聊天，以及赠送礼物均可增加亲密度，与对方的亲密度达到了一定程度即可守护，相互成为彼此的守护天使，语音、视频通话免费~\n',
          activeNames: 147,
        },
        {
          question: '如何取代守护？',
          answer: '请点击到【我的】-【设置】-【隐私设置】界面，关闭排行榜隐身开关，即可隐藏。开关灰色状态为关闭状态。',
          activeNames: 149,
        },
        {
          question: '如何维持亲密度？',
          answer: '每天需新增对方魅力值级别同等的亲密度，即如果对方魅力值是10级，那么每天只需要增加10亲密度就可以了。当守护等级达到“终身守护”时，则双方亲密度永不下降，它将成为一段美丽佳话，永流传在陌生约聊平台。',
          activeNames: 150,
        },
        {
          question: '客服工作时间？',
          answer: '人工客服工作时间为：工作日8：00-17：30',
          activeNames: 151,
        },
        {
          question: '如何上榜？',
          answer: '上榜规则：\n' +
            '1）亲密榜：\n' +
            '①两个人亲密度之和排序\n' +
            '②通过私聊、语音通话、视频通话、互送礼物提高亲密度，上亲密榜\n' +
            '\n' +
            '2）荣耀榜\n' +
            '①荣耀指数总数排序\n' +
            '②可通过私聊、语音通话、视频通话、完成任务、送礼物等获得的荣耀指数，上荣耀榜\n' +
            '\n' +
            '3）女神榜：\n' +
            '①女神指数总数排序\n' +
            '②可通过私聊、语音通话、视频通话、签到、完成任务、收礼物等获得的女神指数，上女神榜\n' +
            '\n' +
            '4）男神榜\n' +
            '①男神指数总数排序\n' +
            '②可通过私聊、语音通话、视频通话、签到、完成任务、收礼物等获得的男神指数，上男神榜。',
          activeNames: 152,
        },
        {
          question: '贵族特权有哪些？',
          answer: '1）点击设置-贵族特权设置，操作相关设置\n' +
            '2）可设置：\n' +
            '①隐身访问：偷偷关心TA，访问TA人不留足迹\n' +
            '②排行榜隐身：除活动榜单外匿名\n' +
            '③守护者隐身：匿名守护，做一个低调的大佬\n' +
            '④隐藏位置：所在地保密，保持神秘',
          activeNames: 153,
        },
        {
          question: '排行榜多久更新一次？',
          answer: '排行榜每隔1小时更新一次',
          activeNames: 154,
        },
        {
          question: '如何上电视？',
          answer: '打开软件首页缘分列表顶部电视飘屏，点“如何上电视”进行设置\n' +
            '上电视要求：\n' +
            '1.如何上表白墙\n' +
            '单次金币价格大于99金币，可上表白墙,\n' +
            '2.如何上电视墙\n' +
            '单次金币价格大于 999 金币，可上电视墙,，并锁屏10秒;\n' +
            '单次金币价格大于2999金币，可上电视墙,，并锁屏20秒;\n' +
            '单次金币价格大于5999金币，可上电视墙，并锁屏30秒。\n' +
            '\n' +
            '3.如何上全服公告\n' +
            '单次金币价格大于 9999 金币，可上全服公告，并锁屏60秒。\n' +
            '单次金币价格大于19999金币，可上全服公告，并锁屏80秒。金额越大，锁屏时间越长。\n' +
            '开通公爵/亲王/帝皇，可上全服公告，并锁屏60秒/80秒/100秒\n' +
            '4.成为守护\n' +
            '成为守护花费金币大于99金币，可上表白墙/电视墙/全服公告，并根据金额锁屏对应时长。',
          activeNames: 155,
        },
        {
          question: '如何发送联系方式？',
          answer: '关于发联系方式问题：\n' +
            '1、双方还不够熟悉(亲密度未达到100°C)的话，贸然留其他联系方式可能存在风险，建议您与对方互动交往一段时间熟悉后，您可以尝试发送联系方式\n' +
            '2、双方互动熟悉亲密度超过100°C后可以尝试发送联系方式，信息只要发送成功，双方均可正常查看到。\n' +
            '3、发送后显示已读，即对方已经成功接收到您的信息。若发送失败，软件聊天页面有相应提醒。\n' +
            '4、添加联系方式建立在双方自主意愿前提下，若对方已读说看不到或其他任何制造平台虚假规则进行欺骗，都是属于违规行为。\n' +
            '5、平台对一切形式存在欺骗性行为严格禁止并坚决打击，发现违规行为可以 及时反馈提供违规账号，一经核实针对违规程度将给予相应的处罚。',
          activeNames: 156,
        },
        {
          question: '超过100度为什么还发不了联系方式？',
          answer: '1)平台鼓励用户真诚交友，双方互动熟悉亲密度超过100°C后可以尝试发送联系方式\n' +
            '2)添加联系方式建立在双方自主意愿前提下，若对方已读说看不到或其他任何制造平台虚假规则进行欺骗，都是属于违规行为。\n' +
            '3) 平台对一切形式存在欺骗性行为严格禁止并坚决打击，一经核实针对违规账号的违规程度将给予相应的处理。',
          activeNames: 501,
        },
        {
          question: '如何提升搭讪推荐？',
          answer: '1)搭讪是根据搜索条件、交友需求账号活跃、违规频次，聊天质量等相关信息进行智能化推荐匹配\n' +
            '2)建议您可以主动一对一聊天提高聊天质量的，或者也可以在首页或者广场多互动。\n',
          activeNames: 157,
        },
        {
          question: '如何修改性别？',
          answer: '性别暂不支持修改，还请您在注册时填写真实信息。平台提倡真人交友，还请谅解~',
          activeNames: 158,
        },
        {
          question: '如何更改年龄？',
          answer: '您好，陌生约聊是真实的交友平台，提倡真诚交友，为保障交友的真实性，实名认证后会显示真实年龄，暂不支持修改哦~ ',
          activeNames: 502,
        },
        {
          question: '充值退款问题？',
          answer: '1)关于充值问题:充值过程中是有几个环节与流程，首先是需要选择充值数额，支付前也是需要确定数额后再进行付款操作，支付时会有弹框提醒二次确认，再进行支付，才可支付成功。\n' +
            '2)充值都是以用户自身需求及自主意愿为前提，用户有充分的选择权及自主决定权，平台不做任何干预。\n' +
            '3)在平台每笔充值及消费都是公开透明，点击收支记录查看相关消费清单。\n' +
            '虚拟产品一经充值成功，不支持退款。已经充值的金币，您可以选择通过聊天/送礼的形式进行消费。\n' +
            '充值贵族成功后，权益立即生效，同样不支持退款。\n',
          activeNames: 159,
        },
        {
          question: '什么是财富值？',
          answer: '1)财富值反映一个用户的慷慨程度,用户消费金币越多，财富值越高。\n' +
            '2)在个人资料页可查看财富等级\n' +
            '3)若使用中不想显示财富值等级，可点击设置，在隐私设置内设置隐藏即可\n' +
            '4)财富等级可通过:送礼物、守护、语音视频通话、语音视频速配、聊天等方式进行升级。',
          activeNames: 12
        },
        {
          question: '什么是魅力值？',
          answer: '1)魅力值反映一个用户的魅力程度,用户获得积分越多，魅力值越高。\n' +
            '2)在个人资料页可查看魅力等级\n' +
            '3)若使用中不想显示魅力值等级，可点击设置，在隐私设置内设置隐藏即可  \n' +
            '4)魅力值等级可通过:获赠礼物、守护、语音视频通话、语音视频速配、聊天等方式进行升级。',
          activeNames: 190
        },
        {
          question: '如何操作隐私设置？',
          answer: '点击到【我的】 - 【设置】 -【隐私设置】\n' +
            '1)可设置隐藏自己的守护天使、守护者、排行榜，礼物\n' +
            '\n' +
            '2)以上设置关闭后，相关信息将对其他人隐藏，仅自己可见\n',
          activeNames: 11
        },
        {
          question: '如何做任务？',
          answer: '您可以点击每日任务有很多任务可以完成哟，例如每日签到、上传照片，音视频等都可以获取免费金币使用哦。',
          activeNames: 13
        },
        {
          question: '如何查看访客记录？',
          answer: '点击到【我的】 - 【设置】 -【隐私设置】' +
            '1)可设置隐藏自己的守护天使、守护者、排行榜，礼物' +
            '2)以上设置关闭后，相关信息将对其他人隐藏，仅自己可见',
          activeNames: 14,
        },
        {
          question: '如何查看对方在不在线？',
          answer: '目前暂无查询在线功能。',
          activeNames: 15,
        },
        {
          question: '如何更改所在地？',
          answer: '陌生约聊致力于打造最真实的交友平台，为体现交友真实性，所在地由系统自动识别，暂不支持修改所在地。',
          activeNames: 17,
        },
        {
          question: '互关视频聊天免费吗？',
          answer: '1）互相关注即是好友，成为好友后完成实名认证双方发送信息是免费的；\n' +
            '2）互相关注与视频通话收费没有关系，与对方互相成为守护天使且达到LV6永结同心，互相守护后音视频通话是免费的\n',
          activeNames: 22,
        },
        {
          question: '视频看不到人怎么办？',
          answer: '视频语音聊天对网络要求比较高，建议在网络环境比较好的情况下试试，或者在手机自带设置找到对应产品软件，操作清除历史数据，缓存试一下。',
          activeNames: 23,
        },
        {
          question: '为什么不能视频？',
          answer: '视频语音聊天对网络要求比较高，建议在网络环境比较好的情况下试试，或者在手机自带设置找到对应产品软件，操作清除历史数据，缓存试一下。',
          activeNames: 25
        },
        {
          question: '视频、语音速配如何使用？',
          answer: '1)视频、语音速配功能需要通过真人认证、语音签名后才能开启权限\n' +
            '2)视频、语音速配能快速匹配有缘人，使用过程中需提高自我保护意识;严禁谩骂，涉黄，广告，讨论敏感话题等行为，若遇不良体验请立即挂断并举报\n' +
            '3)视频、语音速配每分钟通话是系统固定收费，具体扣费明细请在金币清单查询\n' +
            '4)视频、语音速配通话获得积分具体到账明细请在积分清单查询\n' +
            '5)每日视频、语音速配通话系统将会随机赠送金币红包奖励哦',
          activeNames: 26,
        },
        {
          question: '音视频聊天是怎么收费的？',
          answer: '1)视频、语音通话需要通过真人认证、语音签名后才能开启权限\n' +
            '2)视频、语音通话使用过程中需提高自我保护意识；严禁谩骂，涉黄，广告，讨论敏感话题等行为，若遇不良体验请立即挂断并举报\n' +
            '3)视频、语音通话价格设置点击收费设置\n' +
            '4)视频、语音通话获得积分具体到账明细请在积分清单查询\n' +
            '5)双方互相守护等等级达到LV6后，视频语音免费通话\n' +
            '6)每日语音、视频通话系统将会随机赠送金币红包奖励哦。',
          activeNames: 170
        },
        {
          question: '如何设置收费？',
          answer: '陌生约聊平台秉持平台公正公平原则，聊天收费或免费的功能权限完全交由用户自主设置；\n' +
            '点击收费设置设置免费聊天或不同的收费标准；\n' +
            '当对方设置发消息收费时，发消息给对方需付金币，对方12小时内回复即可获得相应积分。\n' +
            '付费聊天，可以主动追求你喜欢的人，并得到及时回应，可靠且高效。\n',
          activeNames: 171
        },
        {
          question: '为什么对方给我点赞或评论货收到私信？',
          answer: '为提升聊天效率、增强互动，当对方给您的头像、相册、语音签名、动态等点赞或评论时，系统会依据平台大数据进行匹配，若匹配度高的男女双方,系统将帮您和对方搭桥牵线，对方点赞消息将同步发送私信通知您，您回复对方则视为接受缘分，判定为主动发送消息方，按照对方的收费设置标准进行付费，互相关注消息免费。',
          activeNames: 172
        },
        {
          question: '为什么没有人回复我？',
          answer: '你可以完善自己的个人资料，写下自己的交友宣言，发布高质量动态，这样会吸引更多人喜欢你，回复你哦~',
          activeNames: 173
        },
        {
          question: '如何更换头像？',
          answer: '1）点击上传头像，更换您的头像\n' +
            '2）请提交本人高清且无遮挡的人脸照片\n' +
            '3）提交后，进入AI智能+人工审核过程，请耐心等待审核，一般2小时内会处理。\n' +
            '4）建议不要频繁提交，若提示“更换头像过于频繁”请明天再试\n' +
            '\n' +
            '温馨提示：真人认证用户必须上传本人真人头像。',
          activeNames: 174
        },
        {
          question: '什么是礼物？',
          answer: '1）礼物可以彰显人气与魅力，礼物越多代表的人气越高，另外可以通过赠送礼物增进与好友之间的联系以及获取更多人的关注\n' +
            '2）可点击【我的】-【资料页】进入礼物墙查看收到的礼物展示\n' +
            '3）礼物消耗金币点击金币清单查询到账明细\n' +
            '4）收礼记录，礼物获得积分点击积分清单查询到账明细，请以实际到账为准\n' +
            '5）礼物获得的积分可以在积分商城兑换提现、金币等\n' +
            '\n' +
            '【温馨提示】：礼物由用户自主自愿赠送，请通过正规途径获得，避免通过欺骗、诱导等违规手段获取，系统检测将给予违规账号相应处罚，严重将导致账号永久禁用。',
          activeNames: 175
        },
        {
          question: '如何发布动态？',
          answer: '1）动态是陌生约聊的社交功能之一，可以通过动态发表图文视频语音，您的粉丝将会在她的动态页面查看到您的最新消息，进行评论、点赞和转发。您也可以查看到您关注的玩家的最新消息喔。\n' +
            '2）点击动态列表，即可发布动态\n' +
            '3）点击我的动态即可查看自己发布的动态内容\n' +
            '4）动态违规原因有：低俗涉黄、打广告、留其他联系方式、政治敏感、宗教迷信、第三方平台信息、二维码、未成年、诋毁辱骂平台或他人等行为\n' +
            '5）动态建议发布正向、积极内容，若检测存在违规敏感信息，将会被系统屏蔽，严重将有可能被封号！\n' +
            '6）若账号被对方拉黑，对方查看不到您的动态\n' +
            '7）删除动态：点击我的动态，点击到动态详情页，点击右上角选项，点击【删除】按钮，删除即可。',
          activeNames: 176
        },
        {
          question: '如何设置拉黑？',
          answer: '1）软件有拉黑功能设置，【聊天会话右上角】-【聊天设置】可设置拉黑\n' +
            '2）拉黑后将不再收到对方的消息和呼叫，且在好友列表互相看不到对方，对方也无法查看动态相关信息\n' +
            '3）拉黑后在发送消息时，聊天页面将会提醒“发送失败，对方已将你拉黑”，将无法与对方进行沟通交流\n' +
            '4）已被拉黑对象可在【我】-【设置】-【黑名单】查看，也可在此页面操作移出黑名单\n' +
            '5）移出拉黑后即双方可正常互动发送信息。',
          activeNames: 177
        },
        {
          question: '如何移除黑名单？',
          answer: '1）软件有拉黑功能设置，【聊天会话右上角】-【聊天设置】可设置拉黑\n' +
            '2）拉黑后将不再收到对方的消息和呼叫，且在好友列表互相看不到对方，对方也无法查看动态相关信息\n' +
            '3）拉黑后在发送消息时，聊天页面将会提醒“发送失败，对方已将你拉黑”，将无法与对方进行沟通交流\n' +
            '4）已被拉黑对象可在【我】-【设置】-【黑名单】查看，也可在此页面操作移出黑名单\n' +
            '5）移出拉黑后即双方可正常互动发送信息。',
          activeNames: 178
        },
        {
          question: '丘比特牵线？',
          answer: '1）丘比特牵线是由系统牵线，希望能匹配到您心仪的人。\n' +
            '2）该功能的特点在于平台会根据用户的搜索条件等相关信息进行智能化推荐，无论男女用户均会收到该推荐。\n' +
            '3）陌生约聊根据用户交友需求进行智能化推荐匹配，匹配算法具有个性化，随机性等特点。正如人与人之间的缘分一样，平台上许多单身男女也因此功能结缘相识，开启自己的爱情故事。',
          activeNames: 179
        },
        {
          question: '如何搜索账号？',
          answer: '1）在软件消息界面-右上角-搜索输入查询ID-【搜索】即可\n' +
            '2）目前只支持通过账号ID搜索查找对方，不支持通过昵称姓名搜索哦。',
          activeNames: 180
        },
        {
          question: '软件聊天如何收费？',
          answer: '关于聊天：\n' +
            '平台为有交友需求的用户双方搭建聊天互动的桥梁，聊天免费或收费的功能权限完全交由用户自主设置；\n' +
            '平台不强制用户充值消费，金币不一定要充值，用户可以通过签到、做任务等方法获取金币；\n' +
            '用户聊天是否产生金币消耗也由用户自主设置，当对方用户设置聊天需付费时发消息需付金币，对方12小时内不回复退还金币。对方用户设置免费时，发消息免费。具体扣费明细请在金币清单查询。\n' +
            '收费模式的设置一方面是为了减少骚扰和垃圾广告行为的出现，另一方面也可以提高交友效率。',
          activeNames: 181
        },

        {
          question: '身份认证已达上限怎么办？',
          answer: '亲，根据平台规则，如果提示“身份证认证已上限”，说明您的身份证认证平台帐号数量已达上限。\n' +
            '您可以先注销掉不用的帐号，等注销成功后再将身份证绑定到现在的账户中，绑定成功后再进行提现（提交注销后的15天后注销成功）。',
          activeNames: 200
        },
        {
          question: '真人认证已达上限怎么办？',
          answer: '亲，根据平台规则，您可明日在进行认证。',
          activeNames: 201
        },
        {
          question: '为什么发送的消息有小感叹号？',
          answer: '亲，请您检查下发送内容中是否出现低俗、涉黄、暴力、时政等敏感词汇，一旦出现，消息会被屏蔽，我们提倡绿色交友，请注意维护绿色交友环境。',
          activeNames: 84
        },
        {
          question: '如何找回之前的账号？',
          answer: '亲，如果想要找回之前的账号，请您确认之前账号绑定的手机号是否还在正常使用，如果在正常使用，您可以选择使用手机号方式进行登录，登录后看到的就是之前的账号。\n' +
            '温馨提醒：\n' +
            '1、如果手机不用了，那么之前的账号就无法找回了，建议重新注册账号使用；\n' +
            '2、如您之前的账号是已经注销了，则不支持恢复。',
          activeNames: 85
        },
        {
          question: '为什么我的账号自动和别人打招呼？',
          answer: '\n' +
            '亲，为了更快地帮您达成交友需求，系统爱神丘比特会主动帮您牵线。\n' +
            '在收到对方的回复后，如果感兴趣可以尝试聊天。\n' +
            '温馨提醒：可以在【我的设置】-【通用设置】中关闭丘比特爱神匹配这项功能。\n',
          activeNames: 87
        },
        {
          question: '为什么没有人打招呼/打招呼变少了/收不到打招呼信息？',
          answer: '陌生约聊独创的打招呼模式是基于大数据进行智能随机匹配，系统将根据账号活跃情况进行匹配。\n' +
            '若长时间未收到打招呼，请确认您是否在设置-通用设置关闭了丘比特牵线；\n' +
            '若收到较少打招呼或打招呼量降低，可通过完善资料、提高主动私聊频率等方式来提升账户质量。',
          activeNames: 202
        },
        {
          question: '为什么消息发不出去？',
          answer: '亲，若您的消息无法发送，请检查是否存在以下情况：\n' +
            '1. 检查网络情况是否良好，建议切换网络后尝试，例如4G网络换为wifi网络\n' +
            '2. 检查发送内容中是否出现违禁词，例如个人联系方式、其他平台的名称缩写等敏感内容\n' +
            '3. 检查发送内容中是否出现低俗、涉黄、暴力、时政等敏感词汇。\n' +
            '4. 检查账户内是否金币不足，请及时充值（贵族聊天也是正常收费的）\n' +
            '5. 如果您被对方拉黑了，也是无法发送出去的。\n' +
            '6.检查自己是否违规',
          activeNames: 88
        },
        {
          question: '消息已读不回的原因？',
          answer: '消息已读：消息发送成功显示已读，即是对方已经成功接收到信息并已查阅。\n' +
            '已读不回：对方可能已读后不在线了或在忙不能及时回复；消息已成功接收是否回复信息取决于对方。',
          activeNames: 89
        },
        {
          question: '如何删除聊天记录？',
          answer: '1）若要删除某一条消息：在私聊页面，选择需删除信息，长按选择删除即可\n' +
            '2）若要删除关于某个人关联的全部信息：在双方消息页面-点击右上角进入【聊天设置】-清空聊天记录\n' +
            '3）若要删除列表：长按消息对话框，选择“清空消息列表”选项，即可清除\n' +
            '\n' +
            '温馨提示：消息删除后即无法恢复。',
          activeNames: 90
        },
        {
          question: '聊天记录相关？',
          answer: '1）为用户账号安全及对用户个人隐私的保护，平台对用户聊天记录不做保存，平台无法也无权利查看，仅用户自己可以查看，请放心使用\n' +
            '2）操作删除聊天记录后，即无法恢复，还请谨慎操作。',
          activeNames: 91
        },
        {
          question: '如何下载陌生约聊app？',
          answer: '1）陌生约聊APP下载：安卓手机用户可以在各大手机应用商店；苹果手机用户可以在App Store\n' +
            '2）注册页面提供了手机号码注册方式，注册即可\n' +
            '3）若软件卸载了可以直接重新安装使用，没有其他限制\n' +
            '4）软件卸载重装，APP内资料信息，账号金币/积分，相关数据均在，登录软件即可查看',
          activeNames: 92
        },
        {
          question: '亲密度如何增加？',
          answer: '您好，和对方聊天消耗10个金币等于1亲密度。您与对方聊天互动、音视频通话、赠送礼物等有金币消耗都会增加亲密度的哦。',
          activeNames: 103
        },
      ],
      searchTerm: "",
      results: [],
      showResults: false,
    };
  },
  name: "Search",
  methods: {
    cancel() {
      this.showResults = false;
      this.searchTerm = '';

    },

    formSubmit() {
      return false
    },
    search() {
      this.showResults = true;
      this.results = [];
      var trimmedSearchTerm = this.searchTerm.trim().toLowerCase();

      if (trimmedSearchTerm !== "") {
        for (var i = 0; i < this.questions.length; i++) {
          var question = this.questions[i];

          if (
            question.question.toLowerCase().indexOf(trimmedSearchTerm) !== -1
          ) {
            this.results.push(question);
          }
        }
      } else {
        this.results = [];
      }
    },
    search2(ev) {
      if (ev.keyCode == 13) {  //键盘回车的编码是13
        ev.preventDefault(); //阻止默认行为
        document.activeElement.blur(); //隐藏软键盘
        this.search();
      }
    },
    formatAnswer(answer) {
      return answer.replace(/\n/g, "<br>");

      // 将换行符（\n）替换为HTML的"<br>"标签

    },
    handleSpanClick(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };

      // 调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value);
      }
    },

  },
  mounted() {
    this.$refs.searchInput.focus()
  }
};
</script>

<style>

.search .search-box {
  height: 30px;

  margin-bottom: 1rem;
}

.search .search-box input {
  height: 35px;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px 0 10px;
  border: 1px solid #ddd;
}

.search .search-box button {
  position: absolute;
  top: 27px;
  right: 20px;
  width: auto;
  color: #939393;
  /*padding: 0.5rem 1rem;*/
  border: none;
  background-color: transparent;
  border-radius: 0.25rem;
  cursor: pointer;
}

.results h3 {
  font-size: 14px;
  margin-bottom: 0.5rem;
}

.results p {
  font-size: 13px;
  margin-bottom: 1rem;
}

.search .search-input {
  height: 35px;
  width: 100%;
  background-color: #fff;
  border-radius: 20px;
  background-image: url(../assets/img/problem-search.png);
  background-repeat: no-repeat;
  background-position: 15px center;
  background-size: 21px;
  text-indent: 42px;
  border: none;
}

.search-input::placeholder {
  padding-right: 20px;
}

.cancel {
  position: relative;
  top: -28px;
  right: -80%;
}

.cancel img {
  width: 20px;
}

.van-icon-circle2 {
  color: #3576F9;
}

.item-content {
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.none {
  width: 50%;
  height: 50%;
  margin: 25%;
}

.search-input::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

.main-container {
  z-index: 999;
  position: relative;
  background-color: #f5f7fb;
  padding: 18px 18px 14px 18px;
}

.content .content-topic:last-child {
  margin-bottom: 70px;
}

.content-topic {
  padding: 0 13px;
  background-color: #ffffff;
  border-radius: 10px;
}

.content-topic .el-collapse {
  border-top: none;
  border-bottom: none;
}

.content-topic .el-collapse-item__header {
  font-size: 15px;
}

.content-topic:last-child .el-collapse-item__header {
  border-bottom: none;
}
</style>




// WEBPACK FOOTER //
// src/page/Search.vue